
$('#submit').click(function(){
  'use strict';
  console.log('username: ' + $('#username').val());
  console.log('password zxc: ' + $('#password').val());
});
